import { IIdValuePair } from 'src/app/core/interfaces/common/common/id-value-pair.interface';

export abstract class AbstractFinancialProfileService {
  abstract loadInvoiceAmount(): Promise<IIdValuePair[]>;
  abstract loadInvoiceTerm(): Promise<IIdValuePair[]>;
}
